import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import classNames from 'classnames/bind';
var bemPreset = {
  b: '',
  e: '__',
  m: '_'
};
export var cnBem = function cnBem(prefix, styles) {
  var cx = classNames.bind(styles);
  var getClassList = function getClassList(b, e, m, mix) {
    var entityName = e ? bemPreset.b + b + bemPreset.e + e : bemPreset.b + b;
    var list = [entityName];
    if (m) {
      var modPrefix = "".concat(entityName).concat(bemPreset.m);
      Object.keys(m).forEach(function (k) {
        if (Object.prototype.hasOwnProperty.call(m, k)) {
          var modVal = m[k];
          if (modVal) {
            list.push(modVal === true ? modPrefix + k : "".concat(modPrefix + k).concat(bemPreset.m).concat(modVal.toString()));
          }
        }
      });
    }
    if (mix !== undefined) {
      (Array.isArray(mix) ? mix : [mix]).forEach(function (value) {
        if (value && typeof value === 'string') {
          value.split(' ').forEach(function (val) {
            if (val !== entityName) {
              list.push(val);
            }
          });
        }
      });
    }
    return list;
  };
  return function (elemOrMods, elemModsOrBlockMix, elemMix) {
    var list;
    if (typeof elemOrMods === 'string') {
      if (typeof elemModsOrBlockMix === 'string' || Array.isArray(elemModsOrBlockMix)) {
        list = getClassList(prefix, elemOrMods, undefined, elemModsOrBlockMix);
      } else {
        list = getClassList(prefix, elemOrMods, elemModsOrBlockMix, elemMix);
      }
    } else {
      list = getClassList(prefix, undefined, elemOrMods, elemModsOrBlockMix);
    }
    return cx.apply(void 0, _toConsumableArray(list));
  };
};